<template>
  <div>
    <!-- <b-alert show variant="primary" class="py-1 px-2 mt-2">
    <b-row >
        <b-col cols="10" lg="11" class="pr-0" align-self="center">
            <small class="">
                <span class="text-capitalize">{{getChildSelectedName}}</span> 
                has wone in this checkList</small>
        </b-col>
        <b-col cols="2" lg="1" class="pl-0 text-center">
            <div class="bg-coin">
                <p class="small font-weight-bolder m-0">{{getChildCoinsBanked}}</p>
            </div>
        </b-col>
    </b-row>
    </b-alert> -->
  </div>
</template>
<script>
    import { mapGetters } from "vuex"
    
    export default {
        computed: {
            ...mapGetters("user", ["getUserName","getChildSelectedName"]),
            ...mapGetters("coins", ["getChildCoinsBanked"])
        }        
    }
</script>
<style scoped>
	.bg-coin{
		background-image: url('../assets/coin.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		color: #F6A724;
	}
	.bg-coin p{
		padding: 12%; 
	}
</style>